import React, { Component } from 'react';

import PropTypes from 'prop-types';

/**
 * Component that alerts if you click outside of it
 */
export default class OutsideClickHandler extends Component {
  constructor(props) {
    super(props);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    const { clickHandler } = this.props;
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      clickHandler();
    }
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  render() {
    const { children } = this.props;
    return <div ref={this.setWrapperRef}>{children}</div>;
  }
}

OutsideClickHandler.propTypes = {
  children: PropTypes.element.isRequired,
  clickHandler: PropTypes.func.isRequired,
};
